import gql from "../gql";
import Jobs from "../fragments/Jobs";
export default gql `
  query Jobs($first: Int, $after: String, $filter: JobFilter) {
    jobs(first: $first, after: $after, filter: $filter) {
      ...Jobs
    }
  }
  ${Jobs}
`;
